import React, { useState } from 'react';
import ShortlistStatusDropdown from './shortlistStatusDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
export const ShortlistHistoryItem = ({
    history,
    folderId,
    candidateId,
    username,
    refreshShortlistDetails,
    onAddNote,
    onEditNote,
    onDeleteNote,
    isLast,
}) => {
    const [note, setNote] = useState('');

    return (
        <div className={`sl-details-history-item ${isLast ? 'is-last' : ''}`}>
            <div className="sl-details-dot" />

            {/* STATUS */}
            <div className="sl-details-status-row">
                {isLast ? (
                    <ShortlistStatusDropdown
                        candidateId={candidateId}
                        folderId={folderId}
                        historyNodeId={history.historyNodeId}
                        currentStatus={history.shortlistStatus}
                        refreshShortlistDetails={refreshShortlistDetails}
                    />
                ) : (
                    <span
                        className={`sl-details-status-badge status-${history.shortlistStatus.toLowerCase()}`}
                    >
                        {history.shortlistStatus}
                    </span>
                )}
            </div>
            <div className="sl-details-status-meta">
                Changed on{' '}
                {new Date(history.createdAt).toLocaleString()} by{' '}
                {history.createdByName || ''}
            </div>

            {/* NOTES */}
            {(history.notes || []).map((n) => {
                const hasNote = n.note && n.note.trim().length > 0;

                if (!hasNote) return null;

                return (
                    <div key={n.id} className="sl-details-note">
                        <div className="sl-details-note-text">{n.note}</div>

                        <div className="sl-details-note-meta">
                            {new Date(n.updatedAt || n.createdAt).toLocaleString()} by {n.createdByName}
                        </div>

                        <div className="sl-details-note-actions top-right">
                            <button
                                type="button"
                                onClick={() =>
                                    onEditNote(folderId, history.historyNodeId, n.id, n.note)
                                }
                            >
                                Edit
                            </button>

                            <button
                                type="button"
                                className="sl-btn-delete-icon"
                                onClick={() =>
                                    onDeleteNote(folderId, history.historyNodeId, n.id)
                                }
                                title="Delete note"
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    </div>
                );
            })}


        </div>
    );
};